import React, { useCallback, useContext, useEffect, useMemo } from "react";

import {
  Context,
  createVideoChapterViewLog,
  fetchCompletionStatuses,
  fetchLessonRetrospectives,
  fetchLessonVideoChapters,
  postCompletedLesson,
  postLessonRetrospectives,
} from "../../../teacherStore";
import VideoLesson from "../../../templates/teacher/VideoLesson";
import { parseQueryParams } from "../../../libs/Util";

export default () => {
  const { state, dispatch } = useContext(Context);

  const lessonId = parseInt(parseQueryParams()["lesson"]);
  const playingChapterId = parseInt(parseQueryParams()["chapter"]);
  const classListInParams = parseQueryParams()["classList"];
  // レンダリングのたびにclassListが異なるメモリに作成され
  // 再度useEffect内の処理が実行してしまうためメモ化
  const classList = useMemo<number[]>(
    () =>
      classListInParams
        ? classListInParams.split(",").map((classID: string) => Number(classID))
        : [],
    [classListInParams],
  );

  const isLessonCompleted =
    state.completion_statuses.completion_statuses.length === 0 ||
    state.completion_statuses.completion_statuses.some(
      status => status.is_completed,
    );

  const postCompletedLessonFunc = () => {
    dispatch(postCompletedLesson(classList, lessonId));
  };

  const postCompletedLessonRetrospectivesFunc = (
    score: number,
    lessonDeliveryScore: number,
    groupWorkScore: number | null,
  ) => {
    dispatch(
      postLessonRetrospectives(
        state.teacher.id,
        classList.join(),
        lessonId,
        score,
        lessonDeliveryScore,
        groupWorkScore,
      ),
    );
  };

  // 関数更新により何度も関数が実行されてしまうため、useCallbackを使用
  const handleFirstVideoPlayFunc = useCallback(() => {
    dispatch(
      createVideoChapterViewLog(
        lessonId,
        playingChapterId,
        JSON.stringify(classList),
      ),
    );
  }, [dispatch, lessonId, playingChapterId, classList]);

  useEffect(() => {
    dispatch(fetchCompletionStatuses(classList, lessonId));
    dispatch(fetchLessonRetrospectives(classList.join(), lessonId));
  }, [dispatch, classList, lessonId]);

  // チャプター切り替え時にワークの完了状態を再取得するため
  // 依存配列にplayingChapterIdを含めている
  useEffect(() => {
    dispatch(fetchLessonVideoChapters(classList, lessonId));
  }, [dispatch, classList, lessonId, playingChapterId]);

  const allVideosUnavailable =
    state.lesson_video_chapters &&
    (state.lesson_video_chapters.video_chapters.length === 0 ||
      state.lesson_video_chapters.video_chapters.every(
        chapter => !chapter.url,
      ));

  if (allVideosUnavailable) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <p>動画教材がないためアクセスできません。</p>
      </div>
    );
  }

  return state.lesson_video_chapters ? (
    <VideoLesson
      lessonVideoChapters={state.lesson_video_chapters}
      playingChapterId={playingChapterId}
      classList={classList}
      prevLessonId={state.prev_lesson_id}
      nextLessonId={state.next_lesson_id}
      isLessonCompleted={isLessonCompleted}
      teacherLessonRetrospectives={state.teacher_lesson_retrospectives}
      postCompletedLesson={postCompletedLessonFunc}
      postCompletedLessonRetrospectives={postCompletedLessonRetrospectivesFunc}
      handleFirstVideoPlay={handleFirstVideoPlayFunc}
    />
  ) : null;
};
